import { ref, watch } from 'vue';
import { refDebounced } from '@vueuse/shared';
import { defineStore } from 'pinia';

import { PostEmployeeList } from '../services/Employees/PostEmployeeList';
import { GetEmployeeList } from '../services/Employees/GetEmployeeList';

export const useAttendanceManagementBatchAddStore = defineStore(
  'attendanceManagementBatchAdd',
  () => {
    const isBatchAddActive = ref(false);
    const batchAddEmployeeList = ref([]);

    const newBatchEmployeeList = ref([
      {
        employee: {
          id: null,
          text: 'Select Employee',
          isListOpen: false,
          biometricId: null,
          isError: false,
          errorMessage: '',
        },
        datePicker: {
          date: null,
          isError: false,
          errorMessage: '',
        },
        timePicker: {
          time: null,
          isError: false,
          errorMessage: '',
        },
        logMode: {
          mode: null,
          options: [
            { text: 'In', value: 0 },
            { text: 'Out', value: 1 },
          ],
          isError: false,
          errorMessage: '',
        },
        project: {
          id: null,
          text: 'Select Project',
          code: null,
          isListOpen: false,
        },
        hasDuplicate: false,
      },
    ]);

    const badgeCounter = ref(false);
    const maximumRowWarningModal = ref(false);
    const showCompanyChangedModal = ref(false);
    const isBatchCompanyChanged = ref(false);
    const clickedApplyFilter = ref(false);
    const batchFilterFirstLoad = ref(true);
    const batchAddMaximumRowModal = ref(false);

    const removeRowConfirationModal = ref({
      rowIndex: null,
      state: false,
      dontShowAgain: false,
    });

    const isProjectSelectDisabled = ref(false);

    const disableResetBtn = ref(true);
    const disableSaveBtn = ref(true);

    const batchAddResetConfirmationModal = ref({
      state: false,
      toast: false,
    });
    const batchAddSaveConfirmationModal = ref({
      state: false,
      toast: false,
    });
    const batchAddMissingFieldsToast = ref(false);
    const batchAddTimesheetLockToast = ref(false);

    const resetBatchAddTable = (type) => {
      newBatchEmployeeList.value = [
        {
          employee: {
            id: null,
            text: 'Select Employee',
            isListOpen: false,
            isError: false,
            errorMessage: '',
          },
          datePicker: {
            date: null,
            isError: false,
            errorMessage: '',
          },
          timePicker: {
            time: null,
            isError: false,
            errorMessage: '',
          },
          logMode: {
            mode: null,
            options: [
              { text: 'In', value: 0 },
              { text: 'Out', value: 1 },
            ],
            isError: false,
            errorMessage: '',
          },
          project: {
            id: null,
            text: 'Select Project',
            code: null,
            isListOpen: false,
          },
          hasDuplicate: false,
        },
      ];
      badgeCounter.value = false;

      if (type === 'reset') {
        batchAddResetConfirmationModal.value.state = false;
        batchAddResetConfirmationModal.value.toast = true;
      }
    };

    const dupicateEntries = ref([]);

    const batchAddDuplicateWarningModal = ref(false);

    const batchAddEmployeeListLoader = ref(false);
    const batchAddEmployeeListCurrentPage = ref(1);
    const batchAddEmployeeListTotalPages = ref(0);

    const batchAddSearchEmployee = ref('');
    const debouncedSearchEmployee = refDebounced(batchAddSearchEmployee, 500);

    watch(debouncedSearchEmployee, async (newVal) => {
      batchAddEmployeeListLoader.value = true;

      batchAddEmployeeList.value = [];

      let params = {
        CompanyId: storedCompanyId.value,
        LocationIds: storedLocationIds.value,
        DepartmentIds: storedDepartmentIds.value,
        SearchString: newVal,
        PageNumber: 1,
        sortColumn: 'LastName',
        sortOrder: 'asc',
        include: ['WorkInformation'],
      };

      batchAddEmployeeListCurrentPage.value = 1;

      getBatchAddEmployeeList(params);
    });

    const getBatchAddEmployeeList = async (params) => {
      let searchCriteriaId;

      await PostEmployeeList(params).then((data) => {
        searchCriteriaId = data.searchCriteriaId;
      });

      await GetEmployeeList({
        Id: searchCriteriaId,
      }).then((result) => {
        const data = result.data.map((d) => d);

        batchAddEmployeeList.value = batchAddEmployeeList.value.concat(data);
        batchAddEmployeeListTotalPages.value = result.pagination.totalPages;
        batchAddEmployeeListLoader.value = false;
      });
    };

    const storedCompanyId = ref();
    const storedDepartmentIds = ref();
    const storedLocationIds = ref();
    const employeeSelectOnloadState = ref(false);

    const applyFilter = (params, reset) => {
      clickedApplyFilter.value = true;

      batchAddEmployeeList.value = [];
      batchAddEmployeeListLoader.value = true;

      isBatchCompanyChanged.value = false;
      showCompanyChangedModal.value = false;

      storedCompanyId.value = params.CompanyId;
      storedDepartmentIds.value = params.DepartmentIds;
      storedLocationIds.value = params.LocationIds;

      getBatchAddEmployeeList(params);

      if (reset) {
        resetBatchAddTable();
      }

      clickedApplyFilter.value = false;
    };

    return {
      isBatchAddActive,
      newBatchEmployeeList,
      badgeCounter,
      maximumRowWarningModal,
      batchAddEmployeeList,
      showCompanyChangedModal,
      isBatchCompanyChanged,
      clickedApplyFilter,
      batchFilterFirstLoad,
      batchAddMaximumRowModal,
      removeRowConfirationModal,
      isProjectSelectDisabled,
      disableResetBtn,
      batchAddResetConfirmationModal,
      disableSaveBtn,
      batchAddSaveConfirmationModal,
      batchAddMissingFieldsToast,
      resetBatchAddTable,
      batchAddTimesheetLockToast,
      dupicateEntries,
      batchAddDuplicateWarningModal,
      batchAddEmployeeListLoader,
      batchAddEmployeeListCurrentPage,
      batchAddEmployeeListTotalPages,
      batchAddSearchEmployee,
      getBatchAddEmployeeList,
      storedCompanyId,
      storedDepartmentIds,
      storedLocationIds,
      employeeSelectOnloadState,
      applyFilter,
    };
  }
);
